import { createContext, useContext } from 'react';

const InsightsReadOnlyContext = createContext(false);

export function InsightsReadOnlyProvider({ readOnly, children }) {
    return (
        <InsightsReadOnlyContext.Provider value={Boolean(readOnly)}>
            {children}
        </InsightsReadOnlyContext.Provider>
    );
}

export function useInsightsReadOnly() {
    return useContext(InsightsReadOnlyContext);
}

export default InsightsReadOnlyContext;
